module.exports = __webpack_public_path__ + "img/sam-nassour-untitled.d71351f.jpg";